import { css, Theme } from '@emotion/react'
import { formHelperTextClasses, outlinedInputClasses } from '@mui/material'
import { scaleBorderRadius } from 'theme/utils'

export const container = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};
`

export const form = () => css`
  flex: 1;
`

export const field = (theme: Theme) => css`
  margin-top: ${theme.spacing(3)};
`

export const valueWrapper = css`
  display: flex;
  flex: 1;

  align-items: center;
`

export const input = (theme: Theme) => css`
  width: 100%;

  .${outlinedInputClasses.root} {
    border: none;
    box-shadow: none;

    background-color: ${theme.colors.backgroundThree};
  }
`

export const fieldArray = (theme: Theme) => css`
  margin-top: ${theme.spacing(2)};

  .${formHelperTextClasses.root} {
    color: ${theme.colors.red};
  }
`

export const textarea = (theme: Theme) => css`
  margin-top: ${theme.spacing(3)};
`

export const title = (theme: Theme) => css`
  display: block;

  margin-top: ${theme.spacing(3)};
  padding-bottom: ${theme.spacing(3)};
  border-bottom: 1px solid ${theme.colors.backgroundOne};

  font-weight: 700;
`

export const featureHeader = (theme: Theme) => css`
  display: flex;
  column-gap: ${theme.spacing(3)};

  margin-top: ${theme.spacing(3)};
  padding: ${theme.spacing(1.5, 17.5, 1.5, 1.5)};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};

  background-color: ${theme.colors.backgroundFive};
`

export const headerCell = css`
  flex: 1;
`

export const popperButton = (theme: Theme) => css`
  height: 36px;
  width: 36px;

  margin-left: ${theme.spacing(1)};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 2.5)};
  border: 1px solid ${theme.colors.backgroundOne};

  svg {
    fill: ${theme.colors.blue};
  }
`

export const featureArrayFieldWrapper = css`
  overflow: hidden;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`

export const featureArrayFieldItem = (theme: Theme) => css`
  min-height: 36px;
  display: flex;
  align-self: flex-start;
  flex: 1;

  margin-right: ${theme.spacing(3)};

  :first-of-type {
    margin-left: ${theme.spacing(0.75)};
  }

  :last-of-type {
    margin-right: ${theme.spacing(2)};
  }
`

export const popperList = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  row-gap: 6px;

  padding: ${theme.spacing(1)};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 4)};

  list-style-type: none;

  background-color: ${theme.backgrounds.backgroundFour};
`

export const popperListButton = (theme: Theme) => css`
  justify-content: flex-start;

  width: 100%;
  padding: ${theme.spacing(1.25)};
  border: none;
  border-radius: ${scaleBorderRadius(theme.shape.borderRadius, 3.5)};

  color: ${theme.colors.typographyTwo};
  font-weight: 500;

  :hover {
    border: none;

    background-color: ${theme.colors.grayHover};
  }

  svg {
    width: auto;
    height: auto;
  }
`

export const buttonsWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: flex-end;
  column-gap: ${theme.spacing(1.25)};

  margin-top: ${theme.spacing(1.25)};
`

export const actionButton = css`
  width: 215px;
`

export const priceRow = css`
  margin-bottom: 15px;
`

export const dummyActions = css`
  width: 120px;
`

export const featureNameAndDecriptionWrapper = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: ${theme.spacing(0.5)};
  overflow: hidden;
`

export const descriptionArrayFieldText = css`
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  color: #8a94a6;
  overflow: hidden;
`
